import React, { useState } from "react";
import { Link } from "react-router-dom";
import "./navbar.css";

export default function Navbar() {
  const [isNavOpen, setIsNavOpen] = useState(false);

  const toggleNav = () => {
    setIsNavOpen(!isNavOpen);
  };

  return (
    <nav className="navbar">
      <div className="container-fluid">
        <Link to="/" className="logo-link">
          <span>RISHABH.AI</span>
        </Link>

        <div className="hamburger" onClick={toggleNav}>
          <div className="line" style={{ transform: isNavOpen ? 'rotate(45deg) translate(5px, 5px)' : 'none' }}></div>
          <div className="line" style={{ opacity: isNavOpen ? 0 : 1 }}></div>
          <div className="line" style={{ transform: isNavOpen ? 'rotate(-45deg) translate(5px, -5px)' : 'none' }}></div>
        </div>

        <ul className={`nav-links ${isNavOpen ? "active" : ""}`}>
          <Link to="/" className="nav-item" onClick={toggleNav}>
            <li>Home</li>
          </Link>
          <Link to="/projects" className="nav-item" onClick={toggleNav}>
            <li>Projects</li>
          </Link>
          <Link to="/about" className="nav-item" onClick={toggleNav}>
            <li>About</li>
          </Link>
          <Link to="/contact" className="nav-item" onClick={toggleNav}>
            <li>Contact</li>
          </Link>
          <div className="nav-actions">
            <a href="/resume.pdf" target="_blank" rel="noopener noreferrer">
              <button className="resume-btn">Resume</button>
            </a>
            <Link to="/contact" onClick={toggleNav}>
              <button className="talk-btn">Let's Talk</button>
            </Link>
          </div>
        </ul>
      </div>
    </nav>
  );
}